import { IEnv } from '../features/whitelabeling/branding/types';
import { env } from './../App/config/env';

export function setAppEnv(appEnv: IEnv) {
  console.log('setAppEnv:', env);
  env.APP_ENV = appEnv;
}
